import { useState, useEffect } from 'react'
import { getDocs, getDoc, doc, collection } from 'firebase/firestore'
import { useLocation } from 'react-router-dom'
import { db } from '../services/firebase'

// Get all projects
export const useProjectsApi = () => {
  const [projects, setProjects] = useState([])

  useEffect(() => {
    // Set subscription to true
    let isSubscribed = true
    const fetchProjects = async () => {
      if (projects.length === 0) {
        const querySnapshot = await getDocs(collection(db, 'projects'))
        querySnapshot.forEach((item) => {
          setProjects((project) => [...project, item.data()])
        })
      }
    }
    // Set state if isSubscribed is true
    if (isSubscribed) {
      fetchProjects()
    }
    // Cancel subscription
    return () => {
      isSubscribed = false
    }
  }, [projects])

  return { projects }
}

// Get one project
export const useProjectApi = (projectId) => {
  const location = useLocation()
  const [project, setProject] = useState([])

  useEffect(() => {
    // Set subscription to true
    let isSubscribed = true
    const fetchProject = async () => {
      const docRef = doc(db, 'projects', projectId)
      const querySnapshot = await getDoc(docRef)
      if (querySnapshot.exists()) {
        setProject(querySnapshot.data())
      }
    }
    // Set state if isSubscribed is true
    if (isSubscribed) {
      fetchProject()
    }
    // Cancel subscription
    return () => {
      isSubscribed = false
    }
  }, [location.pathname])

  return { project }
}

// Get one item
export const useFirestoreItem = (collection, document) => {
  const [item, setItem] = useState([])

  useEffect(() => {
    // Set subscription to true
    let isSubscribed = true
    const fetchItem = async () => {
      const docRef = doc(db, collection, document)
      const querySnapshot = await getDoc(docRef)
      if (querySnapshot.exists()) {
        setItem(querySnapshot.data())
      }
    }
    // Set state if isSubscribed is true
    if (isSubscribed) {
      fetchItem()
    }
    // Cancel subscription
    return () => {
      isSubscribed = false
    }
  }, [])

  return item
}
